// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pause-solid';

export const Component = () => (
  <path d='M10.891 6.485v11.781c0 .383-.143.72-.382 1.054a1.408 1.408 0 0 1-1.054.432h-2.97c-.431 0-.766-.144-1.054-.432A1.408 1.408 0 0 1 5 18.266V6.486c0-.432.144-.767.431-1.055A1.408 1.408 0 0 1 6.485 5h2.97c.43 0 .766.144 1.054.431.239.335.382.67.382 1.054ZM15.298 5h2.97c.43 0 .766.144 1.053.431.288.288.431.623.431 1.054v11.781c0 .432-.143.767-.43 1.054a1.408 1.408 0 0 1-1.055.432h-2.97c-.43 0-.766-.144-1.053-.432-.24-.335-.383-.67-.383-1.054V6.486c0-.384.144-.72.383-1.055A1.408 1.408 0 0 1 15.298 5Z' />
);

export const viewBox = '0 0 25 25';
